import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartProjectFieldPack: FieldPack = {
  id: 'orgchart-project',
  name: 'Project Fields',
  description: 'Project entity fields for cross-functional team assembly workflows',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      label: 'Project Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      sensitivity: 'public',
    },
    {
      id: 'projectCode',
      label: 'Project Code',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 95,
      sensitivity: 'internal',
    },
    {
      id: 'description',
      label: 'Description',
      type: FieldType.TEXT,
      tags: ['notes'],
      priority: 90,
      multiline: true,
      sensitivity: 'internal',
    },
    {
      id: 'projectType',
      label: 'Type',
      type: FieldType.SELECT,
      tags: ['organization'],
      priority: 85,
      options: [
        { value: 'strategic', label: 'Strategic Initiative' },
        { value: 'operational', label: 'Operational' },
        { value: 'compliance', label: 'Compliance' },
        { value: 'innovation', label: 'Innovation' },
        { value: 'transformation', label: 'Transformation' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'status',
      label: 'Status',
      type: FieldType.SELECT,
      tags: ['organization'],
      priority: 80,
      options: [
        { value: 'planned', label: 'Planned' },
        { value: 'active', label: 'Active' },
        { value: 'on_hold', label: 'On Hold' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'priority',
      label: 'Priority',
      type: FieldType.SELECT,
      tags: ['organization'],
      priority: 75,
      options: [
        { value: 'critical', label: 'Critical' },
        { value: 'high', label: 'High' },
        { value: 'medium', label: 'Medium' },
        { value: 'low', label: 'Low' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'startDate',
      label: 'Start Date',
      type: FieldType.DATE,
      tags: ['timeline'],
      priority: 70,
      sensitivity: 'internal',
    },
    {
      id: 'endDate',
      label: 'End Date',
      type: FieldType.DATE,
      tags: ['timeline'],
      priority: 65,
      sensitivity: 'internal',
    },
    {
      id: 'projectManager',
      label: 'Project Manager',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 60,
      sensitivity: 'internal',
    },
    {
      id: 'executiveSponsor',
      label: 'Executive Sponsor',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 55,
      sensitivity: 'internal',
    },
    {
      id: 'department',
      label: 'Owning Department',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 50,
      sensitivity: 'internal',
    },
    {
      id: 'budget',
      label: 'Budget',
      type: FieldType.NUMBER,
      tags: ['compensation'],
      priority: 45,
      min: 0,
      sensitivity: 'hr_confidential',
    },
    {
      id: 'memberCount',
      label: 'Team Size',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 40,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'completion',
      label: 'Completion (%)',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 35,
      min: 0,
      max: 100,
      sensitivity: 'internal',
    },
    {
      id: 'skillsNeeded',
      label: 'Skills Needed',
      type: FieldType.MULTI_SELECT,
      tags: ['skills'],
      priority: 30,
      allowCustomOptions: true,
      sensitivity: 'internal',
    },
  ],
};
